<script>
    import { QueryClientProvider } from '@sveltestack/svelte-query';
    import { getRefreshToken } from 'domain/auth/auth.actions';
    import OtpLogin from 'screens/OtpLogin.svelte';
    import { createHistory, createMemorySource, Route, Router } from 'svelte-navigator';
    import Header from './components/Header.svelte';
    import PrivateRoute from './PrivateRoute.svelte';
    import ChooseNumber from './screens/ChooseNumber.svelte';
    import Channels from './screens/Chat/Channels.svelte';
    import Page from './screens/Chat/Page.svelte';
    import Home from './screens/Home/Home.svelte';
    import Login from './screens/Login.svelte';
    import PageNotExists from 'screens/PageNotExists.svelte';
    import authState from './store/auth';
    import { useCti } from './services/hook';
    import pubsub from 'sweet-pubsub';
    import { onMount } from 'svelte';
    import recieverStore from 'store/reciever';
    import { AmplitudeLogger, openReplay, initSentry } from './services/utils';

    let page = null;
    let params = {};

    const memoryHistory = createHistory(createMemorySource());

    const setUp = async () => {
        initSentry()
        try {
            authState.logout();

            const refresh_token_response = await getRefreshToken();
            if (refresh_token_response) {
                authState.login(refresh_token_response);
            } else {
                authState.logout();
            }
            initOpenReplay($recieverStore.user.personal_email)
            AmplitudeLogger.getLogger($recieverStore.user.personal_email);
        } catch (err) {
            // console.log(err);
            authState.logout();
        }
    };

    const initOpenReplay = email => {
        if (email) {
			openReplay.setUserID(email);
		}
		openReplay.start();
    }

    $: {
        $authState.isLoggedIn ? pubsub.emit('login', {user: $authState.user}) : pubsub.emit('logout');        
    }

    onMount(async () => {
        window.addEventListener('message', function(event) {
            useCti(event.data)
        });
    });

</script>

<QueryClientProvider>
    {#await setUp() then _}
        <main class="conatainer">
            <Header />
            <!-- <div style="margin-top: auto" /> -->
            <Router history={memoryHistory}>
                <Route exact path="/login">
                    <Login />
                </Route>
                <Route exact path="/otp-login">
                    <OtpLogin />
                </Route>

                <div class="main">
                    <PrivateRoute path="/">
                        <Home />
                    </PrivateRoute>
                    <PrivateRoute path="/choose-number">
                        <ChooseNumber />
                    </PrivateRoute>
                    <PrivateRoute path="/channels" primary={false}>
                        <Channels />
                    </PrivateRoute>
                    <PrivateRoute path="/chat/:channel_id" >
                        <Page />
                    </PrivateRoute>
                </div>
                <Route>
                    <PageNotExists />
                </Route>
            </Router>
        </main>
    {/await}
</QueryClientProvider>
